module.exports = __webpack_public_path__ + "static/media/notice_bg_2.043e2150.png";